<template>
  <v-app id="inspire">



    <v-app-bar class="bg-primary" flat height="60">


      <Breadcrums class="mt-3" />
      <v-spacer></v-spacer>
      <NotifIcon class="mx-3" v-if="useUserStore().loggedIn" />
      <UserProfile class="mx-3" v-if="useUserStore().loggedIn" />
    </v-app-bar>

    <v-main>
      <NuxtLoadingIndicator />
      <v-container>
        <v-btn v-if="this.$route.fullPath != '/pim/Peserta'" color="red" variant="outlined" rounded
          class="text-red text-capitalize mb-3" @click="goBack()">
          <v-icon>mdi-arrow-left</v-icon> Kembali</v-btn>
        <NuxtPage />

      </v-container>
    </v-main>



    <FooterRole />
  </v-app>
</template>

<script>

export default {
  components: {
  },
  data: () => ({
    rail: true,
    drawer: false,
    links: [
      { icon: 'mdi-view-dashboard', link: "/LMSPIM", name: "Dashboard" },
      { icon: 'mdi-playlist-edit', link: "/LMSPIM/Pengajar", name: "Pelatihan yang diajar" },
    ],
  }),
  mounted() {

  },
  methods: {
    Logout() {
      const userStore = useUserStore();
      const delay = 700;
      userStore.$patch({
        snackStatus: "green",
        snackbar: true,
        messageSnack: "Logout Berhasil",
        loggedIn: false,
      });
      setTimeout(() => {
        userStore.$reset();
        navigateTo({ path: "/login" });
      }, delay);
    },

    goBack() {
      this.$router.go(-1);
    },

  }
};
</script>

